import { applyLocationBoxLayout } from "../../location/LocationMarker";
import type { BookTimelineLayout } from "@/lib/timeline/book/BookLayout";
import type { TimelineViewTransform } from "../../view/ViewTransform/transform";

export function applyBoardLocationMarkers(
  root: HTMLElement,
  layout: BookTimelineLayout,
  playheadMs: number,
  viewportWidth: number,
  viewportHeight: number,
  view: TimelineViewTransform,
  boardModelDebug = false,
): void {
  applyLocationBoxLayout(
    root,
    layout,
    playheadMs,
    viewportWidth,
    viewportHeight,
    view,
    { boardModelDebug },
  );
}
